import { render, staticRenderFns } from "./BudgetTransferFundsView.vue?vue&type=template&id=2c8cd525"
import script from "./BudgetTransferFundsView.vue?vue&type=script&lang=js"
export * from "./BudgetTransferFundsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports